"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var cloningSteps = require("../helpers/internal-constants").cloningSteps;

var clone = require("../node").clone;

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

var HTMLTemplateElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLTemplateElementImpl, _HTMLElementImpl);

  function HTMLTemplateElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLTemplateElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLTemplateElementImpl).call(this, args, privateData));
    _this._templateContents = _this._ownerDocument.createDocumentFragment();
    return _this;
  }

  _createClass(HTMLTemplateElementImpl, [{
    key: cloningSteps,
    value: function value(copy, node, document, cloneChildren) {
      if (!cloneChildren) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.childrenIterator(node._templateContents)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;
          var childCopy = clone(this._core, child, copy._templateContents._ownerDocument, true);

          copy._templateContents.appendChild(childCopy);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "content",
    get: function get() {
      return this._templateContents;
    }
  }]);

  return HTMLTemplateElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTemplateElementImpl
};